import { useQuery } from "@tanstack/react-query";
import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProfile } from "../services/authService";
import { useLocalStorage } from "./LocalstorageProvider";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const {
    data: accessToken,
    updateLocalStorageData,
    clearLocalStorageData,
  } = useLocalStorage();
  const [user, setUser] = useState(null);

  const { data, error, isLoading } = useQuery({
    queryKey: ["profile", accessToken],
    queryFn: async () => {
      const res = await getProfile();
      if (res?.status === 200) {
        setUser(res?.data);
        return res?.data;
      } else {
        return null;
      }
    },
    enabled: !!accessToken,
  });

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
    clearLocalStorageData();
  };

  return (
    <AuthContext.Provider
      value={{
        user: user || data,
        loading: isLoading,
        status: isLoading
          ? "loading"
          : user?._id || data?._id
          ? "authenticated"
          : "unauthenticated",
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
